import { UserType } from '@/types';
import { CustomerId, InstitutionId, OrganizationId } from '@qmrs/entityid';

export interface RoleResult {
    exists: boolean;
}

export class Roles {
    _items: string[];
    _cache: { [key: string]: RoleResult } = {};

    constructor(items: string[]) {
        this._items = items;
    }

    hasRealmRole(role: string): boolean {
        const cached = this._cache[role];
        if (cached) {
            return cached.exists;
        }
        const exists = this._items.includes(role);
        this._cache[role] = { exists };
        return exists;
    }

    access() {
        const s = this._items.find((v: string) => v.indexOf(':access@') !== -1);
        if (s) {
            return new Access(s);
        }
    }
}

export class Access {
    ty: string = '';
    id: string = '';
    contextId: CustomerId | OrganizationId | InstitutionId | undefined;

    constructor(accessRole: string) {
        const s = accessRole.split(':access@');
        if (s.length === 2) {
            this.ty = s[0];
            this.id = s[1];
        }
    }

    cleanup() {
        this.ty = '';
        this.id = '';
        return false;
    }

    enforce(ty: UserType) {
        let id;
        switch (ty) {
            case UserType.Olb:
                id = CustomerId.parse(this.id);
                if (id.isErr()) {
                    return this.cleanup();
                } else {
                    this.contextId = id.unwrap();
                    return true;
                }
            case UserType.OlbBranch:
            case UserType.Lab:
            case UserType.Wsp:
                id = OrganizationId.parse(this.id);
                if (id.isErr()) {
                    return this.cleanup();
                } else {
                    this.contextId = id.unwrap();
                    return true;
                }
            case UserType.LabBranch:
            case UserType.WspBranch:
                id = InstitutionId.parse(this.id);
                if (id.isErr()) {
                    return this.cleanup();
                } else {
                    this.contextId = id.unwrap();
                    return true;
                }
            case UserType.Hdp:
                if (this.id.startsWith('T')) {
                    id = OrganizationId.parse(this.id);
                    if (id.isErr()) {
                        return this.cleanup();
                    } else {
                        this.contextId = id.unwrap();
                        return true;
                    }
                } else if (this.id.startsWith('R')) {
                    id = InstitutionId.parse(this.id);
                    if (id.isErr()) {
                        return this.cleanup();
                    } else {
                        this.contextId = id.unwrap();
                        return true;
                    }
                }
                return this.cleanup();
            default:
                return this.cleanup();
        }
    }
}
